

/* global BrowserPrint */

// Definir a base URL da API

import React, { useState, useEffect } from 'react';
import {
    Box, Typography, List, ListItem, ListItemText, IconButton, TextField,
    Button, Modal, Grid, Paper, MenuItem, Checkbox, FormControlLabel,Tabs,
    Tab
} from '@mui/material';
import { FaPlus } from 'react-icons/fa';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';
import { Hourglass } from 'react-loader-spinner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import ImpEtiquetas from './impetiquetas';  // sua página de formulário

// Definir a base URL da API
const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local     // IP da rede local

axios.defaults.baseURL = apiBaseURL;
axios.defaults.withCredentials = true;

// Função para obter o token CSRF do cookie
function getCsrfToken() {
    const name = 'csrftoken=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.startsWith(name)) {
            return cookie.substring(name.length);
        }
    }
    return '';
}

// Configurar o header de autorização com o token JWT e CSRF token
axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('access');
    
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    } else {
        console.error('Token JWT não encontrado.');
    }

    // Adicionar o token CSRF em todas as requisições
    config.headers['X-CSRFToken'] = getCsrfToken();

    return config;
});

const Corte = () => {
    const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (_, idx) => setTabIndex(idx);

    const [searchTerm, setSearchTerm] = useState('');
    const [openModal, setOpenModal] = useState(false);
    const [encomendas, setEncomendas] = useState([]);
    const [clientes, setClientes] = useState([]);
    const user = JSON.parse(localStorage.getItem('user'));
    const [selectedEncomenda, setSelectedEncomenda] = useState(null); // Estado para encomenda selecionada
    const [novaEncomenda, setNovaEncomenda] = useState({
        cliente: '',
        referencia: '',
        quantidade: '',
        tamanho: '',
        numero_paletes: '',
        codigoBarras: '',
        lugar: '',
    });
    const [adicionarNovoCliente, setAdicionarNovoCliente] = useState(false);
    const [escolherLugarManual, setEscolherLugarManual] = useState(false);
    const empregadoMap = {
        1: "Admin",
        2: "Sónia Regina da Silva Maio Figueiredo",
        3: "Hélder Manuel Abrantes Ferreira",
        4: "José Carlos Monteiro Menino",
        5: "Francisco Santos Gouveia",
        6: "Alexandre Miguel Pereira Celestino",
        7: "Débora Filipa Soares Pereira",
        8: "Diana Sofia Oliveira Costa",
        9: "Elioenai Ferreira Borges",
        10: "Emília Rosa Correia Ferreira e Rodrigues",
        11: "Fernanda Hellen Vieira Tito",
        12: "Fernando Agostinho dos Santos Nogueira",
        13: "Fernando Viegas André",
        14: "Gabriel Saraiva Moreira",
        15: "Gonçalo Filipe Figueiredo Silveira",
        16: "Igor Augusto Henriques Figueiredo",
        17: "Ísaias Sutério da Silva",
        18: "João Miguel Cerveira Fernandes",
        19: "João Paulo Palma Silvestre",
        20: "Joceline da Paixão Quiala João",
        21: "José Miguel Abrantes Barreira",
        23: "Karla Nayara Vasconcelos Vicente",
        24: "Manuel Fernando da Silva Lelo",
        25: "Mariana Henriques Carvalho Marques",
        26: "Micaela Teresa Dinis Neves Clara",
        27: "Nadiia Khomenchuk",
        28: "Octávio José de Loureiro Marques",
        29: "Paulo Alexandre de Oliveira Albuquerque",
        30: "Renato Daniel Almeida Marques",
        31: "Rogério Filipe Fernandes Correia",
        32: "Sonia Miguel Francisco Passagem",
        33: "Taynara Freitas de Queiroz",
        34: "Yuri Domingos da Silva",
        35: "Açucena Maria Amaral Marques",
        36: "Marco Daniel Loureiro Tavares",
        37: "Bernd Veldman",
        38: "João Carlos Soares Pereira"
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    
    // Carregar o token CSRF e buscar clientes únicos antes de buscar dados da API
    useEffect(() => {
        const token = localStorage.getItem('access');
        if (!token) {
            console.error('Token JWT não encontrado.');
        } else {
            console.log('Token JWT encontrado:', token);
        }


        axios.get('/api/set-csrf/')
            .then(() => {
                fetchEncomendas();
                fetchClientes();
            })
            .catch(error => console.error('Erro ao definir o token CSRF:', error));
    }, []);

    // Função para buscar encomendas da API
    const fetchEncomendas = async () => {
        try {
            const response = await axios.get('/api/encomendas/');
            setEncomendas(response.data.message ? [] : response.data);
        } catch (error) {
            console.error('Erro ao buscar encomendas:', error);
            setEncomendas([]);
        }
    };

    // Função para buscar clientes únicos
    const fetchClientes = async () => {
        try {
            const response = await axios.get('/api/clientes/');
            setClientes(response.data);
        } catch (error) {
            console.error('Erro ao buscar clientes:', error);
        }
    };

    const handleSearchChange = (e) => setSearchTerm(e.target.value);
    const handleModalOpen = () => setOpenModal(true);
    const handleModalClose = () => {
        setOpenModal(false);
        setAdicionarNovoCliente(false);
        setEscolherLugarManual(false);
        setSubmitSuccess(false);
    };

    const handleNovaEncomendaChange = (e) => {
        const { name, value } = e.target;
        setNovaEncomenda((prev) => ({ ...prev, [name]: value }));
    };

    const handleAdicionarNovoCliente = () => {
        setAdicionarNovoCliente(true);
        setNovaEncomenda((prev) => ({ ...prev, cliente: '' }));
    };

    // Função para definir a encomenda selecionada
    const handleEncomendaClick = (encomenda) => {
        setSelectedEncomenda(encomenda);
    };

    // Função para imprimir o ZPL diretamente na impressora
    function enviarZPLParaImpressora(zplCode) {
        BrowserPrint.getDefaultDevice("printer", function(printer) {
            if (printer) {
                printer.send(zplCode, function() {
                    console.log("Etiqueta enviada para a impressora com sucesso.");
                }, function(error) {
                    console.error("Erro ao enviar para a impressora:", error);
                });
            } else {
                console.error("Impressora não encontrada.");
            }
        });
    }

        
        const handleNovaEncomendaSubmit = async () => {
            setIsSubmitting(true);      // Inicia o carregamento
            try {
              const payload = {
                cliente: novaEncomenda.cliente,
                referencia: novaEncomenda.referencia,
                quantidade: novaEncomenda.quantidade,
                tamanho: novaEncomenda.tamanho,
                numero_paletes: novaEncomenda.numero_paletes,
                descricao: novaEncomenda.descricao,
                empregado: user.id,
                adicionarNovoCliente,
                lugar: escolherLugarManual ? novaEncomenda.lugar : null,
              };
        
              const response = await axios.post('/api/encomendas/criar/', payload, {
                responseType: 'text',
              });
              const zplCode = response.data;
              enviarZPLParaImpressora(zplCode);
        
              // Opcionalmente, se o response.data retornar os dados da nova encomenda, você pode:
              const newEncomendaData = response.data;
              setEncomendas([...encomendas, newEncomendaData]);
        
              if (adicionarNovoCliente && novaEncomenda.cliente) {
                setClientes([...clientes, novaEncomenda.cliente]);
              }
        
              // Reseta os campos
              setNovaEncomenda({
                cliente: '',
                referencia: '',
                quantidade: '',
                tamanho: '',
                numero_paletes: '',
                descricao: '',
                lugar: '',
              });
        
              setSubmitSuccess(true);  // Marca que a operação foi bem-sucedida
              handleModalClose();
            } catch (error) {
              console.error('Erro ao adicionar nova encomenda:', error);
            } finally {
              setIsSubmitting(false);  // Encerra o carregamento
              // Opcional: resetar o submitSuccess após alguns segundos para o feedback não ficar fixo
              setTimeout(() => setSubmitSuccess(false), 2000);
            }
            fetchEncomendas();
            fetchClientes();
          };
        
          // Renderização do botão de submit dentro do modal com feedback condicional
          const renderSubmitButtonContent = () => {
            if (isSubmitting) {
              return (
                <Hourglass
                  height="20"
                  width="20"
                  color="#fff"
                  ariaLabel="loading"
                />
              );
            } else if (submitSuccess) {
              return <CheckCircleIcon />;
            } else {
              return "Salvar Encomenda";
            }
          };

    const filteredEncomendas = encomendas.filter((encomenda) =>
        encomenda.cliente && encomenda.cliente.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const renderPaletesTab = () => {
        const filtered = encomendas.filter(e =>
          e.cliente?.toLowerCase().includes(searchTerm.toLowerCase())
        );

    return (
        
            <Box sx={{ display: 'flex' }}>
                <Box sx={{ width: 300, flexShrink: 0, mr: 3 }}>
                    <TextField
                        label="Procurar encomenda"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <List>
    {filteredEncomendas.length > 0 ? (
        <>
            <Typography>{`(${filteredEncomendas.length})`}</Typography>
            {filteredEncomendas.map((encomenda, index) => (
                <ListItem
                    button
                    key={index}
                    onClick={() => handleEncomendaClick(encomenda)} // Define encomenda selecionada
                >
                    <ListItemText 
                        primary={encomenda.referencia} 
                        secondary={`Cliente: ${encomenda.cliente}`} 
                    />
                </ListItem>
            ))}
        </>
    ) : (
        <Typography>Nenhuma encomenda</Typography>
    )}
</List>
                </Box>

                <Box sx={{ flexGrow: 1 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h5">Encomendas</Typography>
                        <IconButton color="primary" onClick={handleModalOpen}>
                            <FaPlus />
                        </IconButton>
                    </Box>

                    <Modal open={openModal} onClose={handleModalClose}>
                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, p: 4 }}>
                            <Typography variant="h6" gutterBottom>Nova Encomenda</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        select={!adicionarNovoCliente}
                                        label="Cliente"
                                        name="cliente"
                                        value={novaEncomenda.cliente}
                                        onChange={handleNovaEncomendaChange}
                                        fullWidth
                                    >
                                        {clientes.map((cliente, index) => (
                                            <MenuItem key={index} value={cliente}>{cliente}</MenuItem>
                                        ))}
                                        <MenuItem onClick={handleAdicionarNovoCliente}>Adicionar novo Cliente</MenuItem>
                                    </TextField>
                                </Grid>
                                {adicionarNovoCliente && (
                                    <Grid item xs={12}>
                                        <TextField label="Nome do Novo Cliente" name="cliente" value={novaEncomenda.cliente} onChange={handleNovaEncomendaChange} fullWidth />
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                <TextField
                                    label="Nome da Encomenda"
                                    name="referencia"
                                    value={novaEncomenda.referencia}
                                    onChange={handleNovaEncomendaChange}
                                    fullWidth
                                    inputProps={{ maxLength: 14 }}
                                />
                                </Grid>
                                <Grid item xs={6}><TextField label="Quantidade" name="quantidade" type="number" value={novaEncomenda.quantidade} onChange={handleNovaEncomendaChange} fullWidth /></Grid>
                                <Grid item xs={6}><TextField label="Tamanho" name="tamanho" value={novaEncomenda.tamanho} onChange={handleNovaEncomendaChange} fullWidth /></Grid>
                                
                                <Grid item xs={6}>
                                    <TextField
                                        label="Número de Paletes"
                                        name="numero_paletes"
                                        type="number"
                                        value={novaEncomenda.numero_paletes}
                                        onChange={handleNovaEncomendaChange}
                                        fullWidth
                                    />
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<Checkbox checked={escolherLugarManual} onChange={(e) => setEscolherLugarManual(e.target.checked)} />}
                                        label="Escolher Lugar Manualmente"
                                    />
                                    {escolherLugarManual && (
                                        <TextField label="Número do Lugar" name="lugar" type="number" value={novaEncomenda.lugar} onChange={handleNovaEncomendaChange} fullWidth />
                                    )}
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                    label="Descrição"
                                    name="descricao"
                                    value={novaEncomenda.descricao}
                                    onChange={handleNovaEncomendaChange}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    placeholder={`23cx 250
1cx 100`}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNovaEncomendaSubmit}
                                        disabled={isSubmitting || submitSuccess}           // ← bloqueia o botão
                                    >
                                        {isSubmitting
                                        ? <HourglassEmptyIcon fontSize="small" />        // spinner simples
                                        : submitSuccess
                                            ? <CheckCircleIcon />
                                            : "Salvar Encomenda"
                                        }
                                    </Button>
                                    </Grid>
                            </Grid>
                        </Box>
                    </Modal>

                    <Paper sx={{ p: 3, mt: 3, position: 'relative' }}>
    <Typography variant="h6">Detalhes da Encomenda Selecionada</Typography>
    {selectedEncomenda ? (
        <>
            <Typography><strong>Cliente:</strong> {selectedEncomenda.cliente}</Typography>
            <Typography><strong>Referência:</strong> {selectedEncomenda.referencia}</Typography>
            <Typography><strong>Data de Entrada:</strong> {new Date(selectedEncomenda.data_entrada).toLocaleDateString()}</Typography>
            <Typography><strong>Quantidade Total de Paletes:</strong> {selectedEncomenda.numero_paletes_total}</Typography>
            
            {/* Mapeia os detalhes de cada palete individual */}
            <Box mt={2}>
                {selectedEncomenda.detalhes.map((palete, index) => (
                    <Box key={index} sx={{ mb: 2, p: 2, border: '1px solid #ccc', borderRadius: '4px' }}>
                        <Typography><strong>Palete {index + 1}</strong></Typography>
                        <Typography><strong>Tamanho:</strong> {palete.tamanho || 'N/A'}</Typography>
                        <Typography><strong>Quantidade:</strong> {palete.quantidade || 'N/A'}</Typography>
                        <Typography><strong>Código de Barras:</strong> {palete.codigo_barras || 'N/A'}</Typography>
                        <Typography><strong>Prateleira:</strong> {palete.prateleira || 'N/A'}</Typography>
                        <strong>Descrição:</strong> {selectedEncomenda.descricao || 'Sem descrição'}
                        <Typography><strong>Adicionado por:</strong> {empregadoMap[palete.empregado] || 'N/A'}</Typography>
                    </Box>
                ))}
            </Box>

            {/* Botão para imprimir a etiqueta */}
            <Button
                variant="contained"
                color="primary"
                onClick={() => enviarZPLParaImpressora(selectedEncomenda.zplCode)} // Certifique-se de que o código ZPL está disponível
                sx={{
                    position: 'absolute',
                    bottom: 16,
                    right: 16,
                }}
            >
                Imprimir Etiqueta
            </Button>
        </>
    ) : (
        <Typography>Selecione uma encomenda na lista à esquerda para visualizar os detalhes.</Typography>
            )}
          </Paper>
        </Box>
      </Box>
    );
  };
return (
    <DashboardLayout>
      <Box sx={{ width: '100%' }}>
        <Tabs value={tabIndex} onChange={handleTabChange}>
          <Tab label="Paletes" />
          <Tab label="Etiquetas" />
        </Tabs>
        <Box sx={{ mt: 2 }}>
          {tabIndex === 0 && renderPaletesTab()}
          {tabIndex === 1 && <ImpEtiquetas />}
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default Corte;
